import { forwardRef } from "react";
import { useId } from "react";
function SvgRawSchoologyIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-name="Layer 1"
      viewBox="0 0 439.84 437.52"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M210.94 232c-35.94-8.59-80.47-18.75-80.47-65.62 0-40.63 34.37-66.41 86.72-66.41 43 0 88.28 20.31 96.09 73.44l-40.62 5.47c-.78-14.07-1.57-25-16.41-35.94-14.84-11.72-32-13.28-43-13.28-29.69 0-44.53 18-44.53 32.81 0 21.09 24.22 28.12 53.91 35.16l21.09 5.46c26.56 6.25 75 18 75 64.85 0 36.72-32 71.09-94.53 71.09-25 0-51.56-5.47-69.53-18-7-5.47-28.91-23.43-33.6-60.93l43-7c-.78 10.16-.78 28.91 16.41 43.75 13.28 11.72 30.47 13.29 45.31 13.29 33.6 0 53.13-13.29 53.13-37.5 0-25.79-19.53-30.47-46.88-35.94Z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M219.53 35.94c-100.78 0-182.81 82.81-182.81 183.59s82 183.59 183.59 183.59 182.81-82.81 182.81-183.59-82-183.59-183.59-183.59m0 403.12C98.44 439.06 0 340.62 0 219.53S98.44 0 219.53 0s220.31 98.44 220.31 219.53-99.22 219.53-220.31 219.53"
        style={{
          fill: "#47b0ed",
        }}
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawSchoologyIcon);
export default ForwardRef;
